/**
 * 세미나 설명·채용 상세 내용의 접힌 미리보기 높이(px) — 긴 이미지 시작점에서 이만큼 보이고 접는다.
 * 2026-10-01 사용자 지시("프리뷰 느낌인데 영역이 너무 작다")로 모바일 240 → 400, PC 360 → 560.
 * 서버 위쪽 파생본(`_top.jpg`)은 가로:세로 3:4 라 이 높이를 덮는다(ImageTopCrop). 파생본이 더 짧으면 파생본 끝까지만 보인다.
 */
export const DESCRIPTION_FOLD_HEIGHT: { mobile: number; pc: number } = { mobile: 400, pc: 560 };
